import { render } from "./App.vue?vue&type=template&id=23f2fd9b"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./assets/scss/library/library.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script